import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import App from './App';
import './index.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element not found');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Register the service worker. registerType: 'autoUpdate' in vite.config.ts
// means new builds activate immediately without prompting; we just kick
// the registration off here.
if (import.meta.env.PROD) {
  registerSW({ immediate: true });
}
